export default function showUserNameOrEmail (user) {
  if (!user) return '';
  if (user.first_name || user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  } else {
    return user.email;
  }
}
